import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
import { business, images } from '../data/business';
const badges = ['badgeTeam', 'badgeGuarantee', 'badgeEco', 'badgeSpanish'] as const;
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="home" className="relative isolate flex min-h-[calc(100vh-7rem)] items-center" data-id="element-220" data-mp="12a0mbehn46w7">
      <img src={images.hero} alt="A 3D Cleaning Services professional in a blue uniform standing beside the branded company SUV in a Houston neighborhood" className="absolute inset-0 -z-10 h-full w-full object-cover object-top" data-id="element-221" data-mp="xanra6gm7tij" />
      <div className="absolute inset-0 -z-10" style={{
      backgroundImage: 'linear-gradient(135deg, rgba(0, 71, 171, 0.35), rgba(30, 144, 255, 0.35))'
    }} aria-hidden="true" data-id="element-222" data-mp="nbydaoruat7k" />

      <div className="mx-auto w-full max-w-4xl px-4 py-20 text-center sm:px-6 lg:py-28" data-id="element-223" data-mp="3j8sezzr63hpb">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-4xl font-extrabold leading-[1.08] tracking-tight text-white drop-shadow-sm sm:text-5xl lg:text-6xl" data-id="element-224" data-mp="3o7lqjmmw8ymu">
          {t(copy.heroTitle)}
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/95 sm:text-lg" data-id="element-225" data-mp="30gq65akrp5pm">
          {t(copy.heroSubtitle)}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-226" data-mp="2hjf8fuesakca">
          <a href="#contact" className="w-full rounded-xl bg-bright px-7 py-4 font-display text-base font-bold text-white shadow-lift transition-colors duration-150 ease-out hover:bg-white hover:text-royal sm:w-auto" data-id="element-227" data-mp="nbbcwylbob5a">
            {t(copy.heroPrimaryCta)}
          </a>
          <a href={business.phoneHref} className="flex w-full items-center justify-center gap-2 rounded-xl border-2 border-blue-600 bg-white px-7 py-4 font-display text-base font-bold text-blue-600 transition-colors duration-150 ease-out hover:bg-gray-50 hover:text-blue-700 sm:w-auto" data-id="element-228" data-mp="1b0vv3f9nj4di">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-229" data-mp="x1ny8t0yo8ch" />
            {t(copy.heroSecondaryCta)}: {business.phone}
          </a>
        </motion.div>

        <ul className="mx-auto mt-12 grid max-w-3xl grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-230" data-mp="3lqug7stmcf76">
          {badges.map((badge, index) => <motion.li key={badge} initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.25,
          delay: 0.2 + index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center justify-center gap-2 rounded-xl bg-navy/30 px-3 py-2.5 text-center backdrop-blur-sm" data-id="element-231" data-mp="1xa429a5swchi" data-mpi={index}>
              <CheckIcon className="h-4 w-4 shrink-0 text-aqua" aria-hidden="true" data-id="element-232" data-mp="2fziz0segefg3" />
              <span className="font-display text-xs font-bold text-white sm:text-sm" data-id="element-233" data-mp="2kxc8bub1zpkl">
                {t(copy[badge])}
              </span>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}